import $C from "@/consts/index";
import $api from '@/apiProvider'
import ChooseOrderTwo from '@/components/modal/ChooseInvoiceOrder'
import ChooseRelationOrder from '@/components/modal/ChooseRelationOrder'
import UploadList from '@/components/common/UploadList'
import Account from '@/components/modal/Account'
import PlatformCorp from '@/components/common/PlatformCorp'
import ChooseCarShip from '@/components/modal/ChooseCarShip'
import SalesMan from '@/components/common/SalesMan'
import {
  orderDetail,
  showLoading,
  hideLoading,
  isNotEmpty,
  isEmpty
} from '@/utils/util'

const assign = (val) => Object.assign({}, val)
const empties = [undefined, '', null, 'null', {},
  []
]
import getAuthOrization from "@/mixin/getAuthOrization";

export default {
  mixins: [getAuthOrization],
  name: 'InvoiceDetail',
  components: {
    SalesMan,
    PlatformCorp,
    ChooseOrderTwo,
    ChooseRelationOrder,
    UploadList,
    ChooseAccount: Account,
    ChooseCarShip
  },
  props: {
    cate: {
      type: String,
      default: ''
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dicByParentData: [],
      tax_rate: [],
      invoiceDetailData: null,

      isShowChooseOrder: false,
      isShowChooseAccount: false,
      isShowChooseCarShip: false,

      invoiceType: $C.invoiceType.options,
      deductType: $C.deductType.options,
      isEdit: false,
      currentRow: {},
      currentChooseColumn: '',
      row: {},
      tableData: [],
      editRules: {
        "invoiceNum": [{
          validator: this.requireValid
        }],
        "addTime": [{
          validator: this.requireValid
        }],
        "invoiceCompName": [{
          validator: this.requireValid
        }],
        "invoiceTitle": [{
          validator: this.requireValid
        }],
        "goodsName": [{
          validator: this.requireValid
        }],
        "counts": [{
          validator: this.requireValid
        }],
        "unit": [{
          validator: this.requireValid
        }],
        "price": [{
          validator: this.requireValid
        }],
        "taxRate": [{
          validator: this.requireValid
        }],
        "taxAmount": [{
          validator: this.requireValid
        }],
        "amount": [{
          validator: this.requireValid
        }]
      },
    };
  },
  watch: {
    isShow: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        //关闭弹窗
        if (val == false && oldVal == true) {
          this.isEdit = false
          this.clearValidate()
        }
      }
    }
  },
  mounted() {
    this.getDictByCode(603, 'tax_rate');
  },
  methods: {
    change(row) {
      this.calcMoneyAll(row);
      this.$refs.xTable.clearValidate()
    },
    async getDictByCode(code, key) {
      let res = await $api.dict.get("searchDic", {
        parentcode: code
      });
      if (res.status === 1) {
        let arr = [];
        let data = res.data;
        data.map(i => {
          arr.push({
            label: i.dictText,
            value: i.dictCode,
          })
        })
        this[key] = arr;
      } else {
        this.$XModal.message(res.message);
      }
    },
    init(invoiceDetailData) {
      this.invoiceDetailData = invoiceDetailData
      this.getData()
    },
    initDetail(id) {
      this.invoiceDetailData = {
        id: id
      };
      this.getData()
    },
    async getData() {
      let queryAction = this.cate == 'Sales' ? 'queryInvoiceSellerDetail' : 'queryInvoiceBuyerDetail'
      let res = await await $api.invoice.request(queryAction, {
        id: this.invoiceDetailData.id
      })
      if (res.status == 1) {
        let row = res.data
        if (row.laydays != null) {
          row.laydays = this.$utils.toDateString(row.laydays, 'yyyy-MM-dd')
        }
        if (row.addTime != null) {
          row.addTime = this.$utils.toDateString(row.addTime, 'yyyy-MM-dd')
        }
        if (row.deductTime != null) {
          row.deductTime = this.$utils.toDateString(row.deductTime, 'yyyy-MM-dd')
        }
        if (row.createTime != null) {
          row.createTime = this.$utils.toDateString(row.createTime, 'yyyy-MM-dd')
        }

        row.orderId = row.ordersBuyerId ? row.ordersBuyerId : (row.ordersBuyerId ? row.ordersBuyerId : null)
        row.orderNum = row.ordersSellerNum ? row.ordersSellerNum : (row.ordersBuyerNum ? row.ordersBuyerNum : null)

        // if (this.cate == 'Sales') {
        //   // row.orderId = row.ordersBuyerId
        //   // row.orderNum = row.ordersBuyerNum
        //   row.sellerName = row.compName
        // } else {
        //   // row.orderId = row.ordersBuyerId
        //   // row.orderNum = row.ordersSellerNum
        //   row.buyerName = row.compName
        // }
        if (isNotEmpty(row.orderNum)) {
          if (row.orderNum.substr(0, 1) == "G") {
            row.sellerName = row.compName;
          } else if (row.orderNum.substr(0, 1) == "S") {
            row.buyerName = row.compName;
          }
        }

        let salesManRes = await $api.baseUserSales.request("querySalesDetail", {
          id: row.salesManId,
          compName: row.compName
        });
        if (salesManRes.status === 1) {
          if (salesManRes.data.rateList && salesManRes.data.rateList.length === 1) {
            row.orderRateDeduct = salesManRes.data.rateList[0].rateDeduct
            row.orderRateDeductManage = salesManRes.data.rateList[0].rateDeductManage
          }
        }

        this.row = row
        this.tableData = [row]
        if (isEmpty(row.fileList) && undefined != this.$refs.uploadList) {
          this.$refs.uploadList.init([])
        }
      } else {
        if (empties.includes(res.message)) res.message = '接口异常'
        this.$XModal.message({
          status: "error",
          message: res.message
        });
      }
    },
    changeDeductType(row) {
      // 1: 价税合计， 2：增值税
      // console.log(row, 'rrr');
      // debugger
      row.rateDeduct = row.deductType === 1 ? row.orderRateDeduct : row.orderRateDeductManage
      this.calcMoney(row, 'rateDeduct')
      // row.rateDeduct = 1
    },
    getInvoiceTitle(val) {
      if (val) {
        this.tableData[0].rateDeduct = null
        this.tableData[0].deductType = null
        this.tableData[0].salesMan = null
        this.tableData[0].rateManage = null
        this.tableData[0].manageAmount = null
      }
    },
    getSaleManInfo(val) {
      let row = this.tableData[0]
      row.orderRateDeduct = null
      row.orderRateDeductManage = null
      row.rateManage = null
      row.rateDeduct = null
      row.deductType = null
      if (this.cate == 'Sales') {
        if (row.invoiceCompName && val.rateList && val.rateList.length > 0) {
          let obj = val.rateList.filter(item => item.compName == row.invoiceCompName)
          if (obj && obj.length > 0 && obj[0].rateManage) {
            row.rateManage = obj[0].rateManage
          }
          this.calcMoney(row, 'rateManage')
        }
      } else {
        if (row.invoiceTitle && val.rateList && val.rateList.length > 0) {
          let obj = val.rateList.filter(item => item.compName == row.invoiceTitle)
          if (obj && obj.length > 0 && obj[0].rateManage) {
            row.orderRateDeduct = obj[0].rateDeduct
            row.orderRateDeductManage = obj[0].rateDeductManage
          }
        }
      }
    },
    getDicByParentList() {
      $api.other.getDicByParentModel
        .GET({
          params: {
            page: 1,
            rows: 10,
          },
        })
        .then((res) => {
          this.dicByParentData = res.data;
        });
    },
    clearValidate() {
      this.$refs.t1.clearValidate()
      this.$refs.t2.clearValidate()
      this.$refs.t3.clearValidate()
    },
    async requireValid(e) {
      if (e.column.title == '发票号' && isNotEmpty(e.row.invoiceNum)) {
        let rep = /^(\d{8})?$/
        let invoiceNum = e.row.invoiceNum.trim()
        if (!rep.test(invoiceNum)) {
          return Promise.reject(new Error('请输入正确的发票号码'))
        }
      }
      if (this.cate === "Income" && e.column.title == '抵扣日期' && isEmpty(e.row.deductTime)) {
        return Promise.reject(new Error('抵扣日期不能为空'))
      }
      if (empties.includes(e.cellValue)) {
        return Promise.reject(new Error(e.column.title + '必填'))
      }
    },
    async validEvent() {
      const errMap1 = await this.$refs.t1.validate().catch((errMap1) => errMap1);
      if (errMap1) return false
      const errMap2 = await this.$refs.t2.validate().catch((errMap2) => errMap2);
      if (errMap2) return false
      const errMap3 = await this.$refs.t3.validate().catch((errMap3) => errMap3);
      if (errMap3) return false
      return true
    },
    editEvent() {
      this.isEdit = true
    },
    setEdit(isEdit) {
      this.isEdit = isEdit
    },
    //单元格点击事件
    // { row, rowIndex, $rowIndex, column, columnIndex, $columnIndex, triggerRadio, triggerCheckbox, triggerTreeNode, triggerExpandNode, $event }
    async cellClickEvent(e) {
      let row = e.row
      let field = e.column.property
      if (this.isEdit) {
        switch (field) {
          case 'chainNum':
          case 'orderNum':
            this.currentRow = e.row
            this.isShowChooseOrder = true
            this.$refs.chooseOrder.init()
            break;
        }
      } else {
        if (field == 'chainNum' && !empties.includes(row.chainId)) {
          orderDetail(this, 0, row.chainId)
        } else if (field == 'orderNum') {
          if (this.cate == 'Sales' && !empties.includes(row.ordersBuyerId)) {
            orderDetail(this, 1, row.ordersBuyerId)
          } else if (this.cate != 'Sales' && !empties.includes(row.ordersSellerId)) {
            orderDetail(this, 2, row.ordersSellerId)
          }
        }
      }
    },
    openChooseAccount(row, field) {
      if (!this.isEdit) {
        event.preventDefault()
        return this.needEdit()
      }
      this.currentRow = row
      this.currentChooseColumn = field
      this.isShowChooseAccount = true
      this.$refs.chooseAccount.init()
    },
    async chooseOrderEvent(order) {
      console.log('chooseOrderEvent', order)
      // debugger
      // if (this.cate == 'Sales') {
      //     this.currentRow.ordersBuyerId = order.id
      //     this.currentRow.orderNum = order.buyerOrdersNum
      // } else {
      //     this.currentRow.ordersSellerId = order.id
      //     this.currentRow.orderNum = order.sellerOrdersNum
      // }
      this.currentRow.buyerNameRela = order.buyerName;
      this.currentRow.sellerNameRela = order.sellerName;
      if (this.cate == 'Sales') {
        // 开票
        if (order.orderType === 1) {
          this.currentRow.ordersBuyerId = order.id;
          this.currentRow.orderNum = order.buyerOrdersNum;
          this.currentRow.invoiceCompName = order.sellerName
          this.currentRow.platformCompanyId = order.platformCompanyId
          this.currentRow.invoiceTitle = order.buyerName
          this.currentRow.ordersSellerId = null;
          this.currentRow.ordersSellerNum = null;
        } else {
          this.currentRow.ordersSellerId = order.id;
          this.currentRow.orderNum = order.sellerOrdersNum;
          this.currentRow.invoiceCompName = order.sellerName
          this.currentRow.platformCompanyId = order.platformCompanyId
          this.currentRow.invoiceTitle = order.platformCompany;
        }
      } else {
        // 抵扣票
        if (order.orderType === 2) {
          this.currentRow.ordersSellerId = order.id
          this.currentRow.orderNum = order.sellerOrdersNum
          this.currentRow.invoiceCompName = order.sellerName
          this.currentRow.platformCompanyId = order.platformCompanyId
          this.currentRow.invoiceTitle = order.buyerName
          this.currentRow.ordersSellerIdLv2 = null;
          this.currentRow.ordersSellerNumLv2 = null

        } else {
          this.currentRow.ordersSellerIdLv2 = order.id
          this.currentRow.orderNum = order.sellerOrdersNum
          this.currentRow.invoiceCompName = order.sellerName
          this.currentRow.platformCompanyId = order.platformCompanyId
          this.currentRow.invoiceTitle = order.buyerName
        }
        // this.currentRow.ordersSellerId = order.id
        // this.currentRow.orderNum = order.sellerOrdersNum
      }
      //订单信息
      this.currentRow.chainId = order.chainId
      this.currentRow.chainNum = order.chainNum

      this.currentRow.buyerName = order.buyerName
      this.currentRow.sellerName = order.sellerName

      // 会带入，开票单位、发票抬头、应税商品名称、数量、单位
      // this.currentRow.invoiceCompName = order.sellerName
      // this.currentRow.invoiceTitle = order.buyerName
      this.currentRow.rateDeduct = order.rateDeduct

      if (!this.isEdit) {
        if (!empties.includes(order.goodsRtnVos) && order.goodsRtnVos.length > 0) {
          this.currentRow.goodsName = order.goodsRtnVos[0].goodsName
          this.currentRow.counts = order.goodsRtnVos[0].counts
          this.currentRow.unit = order.goodsRtnVos[0].unit
        }
      }

      if (isNotEmpty(order.salesMan)) {
        this.currentRow.salesMan = order.salesManName
        this.currentRow.salesManId = order.salesMan
        this.currentRow.isOrderSalesMan = true
        // this.currentRow.orderRateDeduct = order.rateDeduct
        // this.currentRow.orderRateDeductManage = order.rateDeductManage
        let paramsObj;
        if (this.cate == 'Sales') {
          paramsObj = {
            id: order.salesMan,
            compName: this.currentRow.invoiceCompName
          }
        } else {
          paramsObj = {
            id: order.salesMan,
            compName: this.currentRow.invoiceTitle
          }
        }

        let res = await $api.baseUserSales.request("querySalesDetail", paramsObj);
        if (res.status === 1) {
          if (res.data.rateList && res.data.rateList.length === 1) {
            this.currentRow.orderRateDeduct = res.data.rateList[0].rateDeduct
            this.currentRow.orderRateDeductManage = res.data.rateList[0].rateDeductManage
            this.currentRow.rateManage = res.data.rateList[0].rateManage
          } else {
            this.currentRow.orderRateDeduct = null
            this.currentRow.orderRateDeductManage = null
            this.currentRow.rateManage = null
          }
        }
        // console.log(this.currentRow, 'this.currentRow');
        // debugger
      }

      this.isShowChooseOrder = false
      this.clearValidate()
    },
    chooseAccountEvent(account, type) {
      console.log('chooseAccountEvent', account)
      if (type == 'company') {
        this.currentRow[this.currentChooseColumn] = account.compName
      } else {
        this.currentRow[this.currentChooseColumn] = account.userName
      }
      this.isShowChooseAccount = false

      this.clearValidate()
    },
    showChooseCarShip(row) {
      if (!this.isEdit) {
        event.preventDefault()
        return this.needEdit()
      }
      this.currentRow = row
      this.isShowChooseCarShip = true
      this.$refs.chooseCarShip.init()
    },
    chooseCarShip(data, cate) {
      this.currentRow.carShipNum = (cate == 'car' ? data.carNum : data.shipName)
      this.isShowChooseCarShip = false
    },
    async submitEvent() {
      let sts = await this.validEvent()
      if (!sts) {
        this.$XModal.message({
          status: "error",
          message: "校验不通过！"
        });
        return
      }

      let row = assign(this.tableData[0])

      if (row.laydays != null && row.laydays != '') {
        row.laydays = this.$utils.timestamp(this.$utils.toStringDate(row.laydays))
      }
      if (row.laydays == 'Invalid Date') {
        row.laydays = null
      }
      if (row.addTime) {
        row.addTime = this.$utils.timestamp(this.$utils.toStringDate(row.addTime))
      }
      if (row.deductTime) {
        row.deductTime = this.$utils.timestamp(this.$utils.toStringDate(row.deductTime))
      }
      if (row.cteateTime) {
        row.cteateTime = this.$utils.timestamp(this.$utils.toStringDate(row.cteateTime))
      }
      if (row.taxTotalAmount) {
        row.amount = row.taxTotalAmount
      }

      row.orderNum = null
      row.compName = this.cate == 'Sales' ? row.invoiceCompName : row.invoiceTitle
      let action = this.cate == 'Sales' ? 'updateInvoiceSeller' : 'updateInvoiceBuyer'

      showLoading()
      let res = await $api.invoice.request(action, row)
      hideLoading()

      if (res.status == 1) {
        this.$XModal.message('提交成功')
        this.$emit('close')
        this.$emit('init')
      } else {
        if (!res.message) {
          res.message = '接口异常'
        }
        this.$XModal.message(res.message)
      }
    },
    needEdit() {
      this.$XModal.message('编辑状态下才可操作')
    },
    // calcMoney(row, field) {
    //   // row.counts = isNaN(parseInt(row.counts)) ? 0 : row.counts
    //   // row.price = isNaN(parseInt(row.price)) ? 0 : row.price
    //   // row.taxRate = isNaN(parseInt(row.taxRate)) ? 0 : parseInt(row.taxRate)
    //   // if (['counts', 'price', 'taxRate'].includes(field)) {
    //   //     let priceAmount = parseInt(row.counts * row.price * 100) / 100
    //   //     row.taxAmount = parseInt(priceAmount * row.taxRate) / 100
    //   //     row.amount = row.taxAmount + priceAmount
    //   // } else {
    //   //     row.taxAmount = row.taxAmount > 0 ? parseFloat(row.taxAmount).toFixed(2) : 0
    //   //     row.amount = row.amount > 0 ? parseFloat(row.amount).toFixed(2) : 0
    //   // }
    //   // row.counts = isNaN(parseInt(row.counts)) ? '' : row.counts
    //   // row.price = isNaN(parseInt(row.price)) ? '' : row.price
    //   // row.taxRate = isNaN(parseInt(row.taxRate)) ? '' : parseInt(row.taxRate)
    //   // row.rateManage = isNaN(parseInt(row.rateManage)) ? '' : row.rateManage
    //   // row.rateDeduct = isNaN(parseInt(row.rateDeduct)) ? '' : row.rateDeduct
    //   //['counts', 'price', 'taxRate', 'rateManage', 'rateDeduct'].includes(field)
    //   if (['counts', 'price', 'taxRate', 'rateManage', 'rateDeduct'].includes(field)) {
    //     let priceAmount = Math.round(row.counts * row.price * 100) / 100
    //     row.taxAmount = Math.round(priceAmount * row.taxRate) / 100
    //     row.totalAmount = priceAmount
    //     row.taxTotalAmount = Math.round((row.taxAmount + priceAmount) * 100) / 100;
    //     row.amount = row.taxTotalAmount
    //     let rate = this.cate === "Income" ? row.rateDeduct : row.rateManage
    //     row.manageAmount = Math.round(row.taxTotalAmount * rate) / 100;
    //     console.log(rate, row.taxTotalAmount, row.manageAmount, 'rate');
    //   }

    //   this.$refs.t3.updateStatus()
    // },

    calcMoney(row, field) {
      // row.counts = isNaN(row.counts) ? '' : row.counts
      // row.price = isNaN(row.price) ? '' : row.price
      if (row.counts !== '' && row.price !== '') {
        let priceAmount = Math.round(row.counts * row.price * 100) / 100;
        row.totalAmount = isNaN(parseInt(priceAmount)) ? '' : priceAmount;
        this.calcMoneyAll(row);
      } else {
        row.totalAmount = ''
      }
    },
    calcMoneyAll(row) {
      // row.taxRate = isNaN(parseInt(row.taxRate)) ? '' : row.taxRate;
      // row.totalAmount = isNaN(parseInt(row.totalAmount)) ? '' : row.totalAmount;
      if (row.taxRate !== '' && row.totalAmount !== '') {
        row.taxAmount = Math.round(row.totalAmount * row.taxRate) / 100;
        this.calcMoneySecAll(row)
      } else {
        row.taxAmount = ''
      }
    },
    calcMoneySecAll(row) {
      // row.taxAmount = isNaN(parseInt(row.taxAmount)) ? '' : row.taxAmount;
      // row.totalAmount = isNaN(parseInt(row.totalAmount)) ? '' : row.totalAmount;
      if (row.taxAmount !== '' && row.totalAmount !== '') {
        row.taxTotalAmount = Math.round((parseFloat(row.taxAmount) + parseFloat(row.totalAmount)) * 100) / 100;
        this.calcMoneyTreAll(row)
      } else {
        row.taxTotalAmount = ''
      }
    },
    calcMoneyTreAll(row) {
      let rate = this.cate === "Income" ? row.rateDeduct : row.rateManage;
      // row.taxTotalAmount = isNaN(parseInt(row.taxTotalAmount)) ? '' : row.taxTotalAmount;
      rate = isNaN(parseInt(rate)) ? '' : rate;

      if (rate !== '' && rate !== '') {
        row.manageAmount = Math.round(row.taxAmount * rate) / 100;
      } else {
        row.manageAmount = ''
      }
    },
    authUpdate() {
      return this.cate == 'Sales' && this.isHavePermission('invoice:updateInvoiceSeller') || this.cate == 'Income' && this.isHavePermission('invoice:updateInvoiceBuyer')
    },
  },
};